"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CamundaExecutionListener = void 0;
/**
 * Describes a single Camunda specific ExecutionListener.
 * These are wrapped in the <camunda:executionlistener></camunda:executionlistener> tag.
 */
class CamundaExecutionListener {
}
exports.CamundaExecutionListener = CamundaExecutionListener;
//# sourceMappingURL=CamundaExecutionListener.js.map